/**
 * AWS Bedrock Model IDs
 * Use these constants instead of hardcoded strings throughout the frontend
 *
 * Note: keep these in sync with the backend constants in
 * app/constants/bedrock-models.ts. Bedrock retires dated model snapshots on a
 * schedule — when a model nears EOL, bump the ID here and in the backend copy.
 */
export const BEDROCK_MODEL_IDS = {
  CLAUDE_SONNET_4_5: 'us.anthropic.claude-sonnet-4-5-20250929-v1:0',
  CLAUDE_HAIKU_4_5: 'us.anthropic.claude-haiku-4-5-20251001-v1:0',
} as const

export type BedrockModelId = typeof BEDROCK_MODEL_IDS[keyof typeof BEDROCK_MODEL_IDS]
